import { API } from './resources'

export default {
  login: (email, username, password, doubleOptIn, redirect, loginSource) => {
    return API.post('/users/login', { email, username, password, doubleOptIn, redirect, loginSource })
  },
  logout: () => {
    return API.post('/users/logout')
  },
  signup: (data) => {
    return API.post('/users/signup', data)
  },
  bulkSignup: (emails, sendVerification) => {
    return API.post('/users/signup/bulk', { emails, sendVerification })
  },
  createAccountFromEngcom: (hubspotTrackingId, utmSource, referralCode) => {
    return API.post('/users/signup/engcom', { hubspotTrackingCode: hubspotTrackingId, utmSource, referralCode })
  },
  verify: (username, code) => {
    return API.post(`/users/${username}/verify`, { code })
  },
  limitedLogin: (email, scope, code) => {
    return API.post('/users/login/limited', { email, scope, code })
  },
  current: () => {
    return API.get('/users/current')
  },
  refresh: (username, token) => {
    return API.post(`/users/${username}/refresh`, { token })
  },
  getAll: (limit, offset, query) => {
    return API.get('/users', { params: { limit, offset, query } })
  },
  getAllLikeName: (limit, offset, query) => {
    return API.get('/users/find', { params: { limit, offset, query } })
  },
  getAllLikeSchoolName: (limit, offset, query, searchBy) => {
    return API.get('/schools/find', { params: { limit, offset, query, searchBy } })
  },
  get: (username) => {
    return API.get(`/users/${username}`)
  },
  getUserFullProfileFromEngcom: (username) => {
    return API.get(`/users/${username}/engcom/profile`)
  },
  update: (username, data) => {
    return API.put(`/users/${username}`, data)
  },
  getProfile: (username) => {
    return API.get(`/users/${username}/profile`)
  },
  updateProfile: (username, data) => {
    return API.put(`/users/${username}/profile`, data)
  },
  updateProfileOccupation: (username, data) => {
    return API.put(`/users/${username}/profile/occupation`, data)
  },
  updateSomeProfileInfo: (username, data) => {
    return API.put(`/users/${username}/profilesome`, data)
  },
  onlineCount: () => {
    return API.get('/users/onlinecount')
  },
  setInterests: (username, data) => {
    return API.put(`/users/${username}/profile/interests`, data)
  },
  getCategories: (username) => {
    return API.get(`/users/${username}/categories`)
  },
  getFilters: () => {
    return API.get('/users/filters')
  },
  setFilter: (username, data) => {
    return API.post(`/users/${username}/filter`, data)
  },
  getFilterTags: (username) => {
    return API.get(`/users/${username}/filter/tags`)
  },
  setCategories: (username, data) => {
    return API.put(`/users/${username}/categories`, data)
  },
  setSkills: (username, data) => {
    return API.put(`/users/${username}/profile/skills`, data)
  },
  isFollowing: (username, other) => {
    return API.get(`/users/${username}/follow/${other}`)
  },
  follow: (username, other) => {
    return API.post(`/users/${username}/follow/${other}`)
  },
  unfollow: (username, other) => {
    return API.delete(`/users/${username}/follow/${other}`)
  },
  updateUserType: (username, type) => {
    return API.put(`/users/${username}/usertype`, { userType: type })
  },
  updateEventAndPartnerIDs: (username) => {
    return API.put(`/users/${username}/event-partner`)
  },
  getFollowing: (username, limit, offset, count) => {
    return API.get(`/users/${username}/following`, { params: { limit, offset, count } })
  },
  getProjectContributions: (username, limit, offset, sort, filter) => {
    return API.get(`/users/${username}/contributions/projects`, { params: { limit, offset, sort, filter } })
  },
  getAllContributions: (username, limit, offset, sort, filter, count) => {
    return API.get(`/users/${username}/contributions`, { params: { limit, offset, sort, count, filter } })
  },
  getComments: (username, limit, offset) => {
    return API.get(`/users/${username}/comments`, { params: { limit, offset } })
  },
  getWhiteboards: (username, limit, offset) => {
    return API.get(`/users/${username}/contributions/whiteboard`, { params: { limit, offset } })
  },
  getFollowers: (username, limit, offset, count) => {
    return API.get(`/users/${username}/followers`, { params: { limit, offset, count } })
  },
  getSubscriptions: (username, limit, offset, includeCreated, sort, filter, currentPage) => {
    return API.get(`/users/${username}/subscriptions`, { params: { limit, offset, sort, query: includeCreated, filter, currentPage } })
  },
  getSubscribedProjectIDs: (username) => {
    return API.get(`/users/${username}/subscriptions/ids`)
  },
  getLikedProjects: (username, limit, offset) => {
    return API.get(`/users/${username}/likes/projects`, { params: { limit, offset } })
  },
  getLikedProjectIDs: (username) => {
    return API.get(`/users/${username}/likes/projects/ids`)
  },
  getLikedPosts: (username, limit, offset) => {
    return API.get(`/users/${username}/likes/posts`, { params: { limit, offset } })
  },
  getLikedPostIDs: (username) => {
    return API.get(`/users/${username}/likes/posts/ids`)
  },
  getLikedComments: (username, limit, offset) => {
    return API.get(`/users/${username}/likes/comments`, { params: { limit, offset } })
  },
  getLikedCommentIDs: (username) => {
    return API.get(`/users/${username}/likes/comments/ids`)
  },
  getLikedMessages: (username, limit, offset) => {
    return API.get(`/users/${username}/likes/messages`, { params: { limit, offset } })
  },
  getLikedMessageIDs: (username) => {
    return API.get(`/users/${username}/likes/messages/ids`)
  },
  getByInterest: (interest) => {
    return API.get(`/interests/${interest}/users`)
  },
  getBySkill: (skill) => {
    return API.get(`/skills/${skill}/users`)
  },
  getProjects: (username, data) => {
    return API.post(`/users/${username}/projects`, data)
  },
  getLastProject: (username) => {
    return API.get(`/users/${username}/projects/last`)
  },
  getLastDraft: (username) => {
    return API.get(`/users/${username}/projects/draft`)
  },
  resetPassword: (username, email) => {
    return API.post('/users/reset', { username, email })
  },
  changePassword: (username, password, oldPassword, passwordResetCode) => {
    return API.put(`/users/${username}/password`, { password, oldPassword, passwordResetCode })
  },
  createPassword: (username, password) => {
    return API.put(`/users/${username}/createPassword`, { password })
  },
  changeEmail: (username, email) => {
    return API.put(`/users/${username}/email`, { email })
  },
  check: (username, email) => {
    return API.post('/users/check', { username, email })
  },
  getSettings: (username) => {
    return API.get(`/users/${username}/settings`)
  },
  updateSettings: (username, settings) => {
    return API.put(`/users/${username}/settings`, settings)
  },
  checkLastVerified: (uuid) => {
    return API.get('/users/check/verified', { params: { uuid } })
  },
  acceptInvite: (uuid, projectID, code, username, password, receiveEmails) => {
    return API.post('/users/invite', { uuid, projectID: parseInt(projectID), code, username, password, receiveEmails })
  },
  setBadges: (username, data) => {
    return API.put(`/users/${username}/profile/badges`, data)
  },
  getFirebaseToken: () => {
    return API.get('/users/firebase/token')
  },
  firebaseLogin: (data) => {
    return API.post('/users/login/firebase', data)
  },
  replaceTags: (username, data) => {
    return API.put(`/users/${username}/profile/tags`, data)
  },
  addTags: (username, data) => {
    return API.put(`/users/${username}/profile/addtags`, data)
  },
  tagAndAddToGroup: (username, data) => {
    return API.put(`/users/${username}/tagAndFollow`, data)
  },
  updateUserInfo: (username, data) => {
    return API.put(`/users/${username}/updateUserInfo`, data)
  },
  surveySignupSource: (username, data) => {
    return API.put(`/users/${username}/signupSource`, data)
  },
  saveLocationData: (username, data) => {
    return API.post(`/users/${username}/location`, data)
  },
  saveYscUserInfo: (username, data) => {
    return API.put(`/users/${username}/profile/yscinfo`, data)
  },
  getYscUserInfo: () => {
    return API.get('/users/yscinfo')
  },
  getAjasProjectTags: () => {
    return API.get('/users/ajastags')
  },
  getAjasUserRole: () => {
    return API.get('/users/ajasrole')
  },
  getPartnerUserInfo: () => {
    return API.get('/users/partnerinfo')
  },
  setTeacherType: (userID, userType) => {
    return API.put(`/users/${userID}/type/${userType}`)
  },
  SaveIsefUserInfo: (username, data) => {
    return API.post(`/users/${username}/isefinfo`, data)
  },
  SaveGASUserInfo: (username, data) => {
    return API.post(`/users/${username}/gasinfo`, data)
  },
  saveAjasUserInfo: (username, data) => {
    return API.post(`/users/${username}/partnerinfo`, data)
  },
  saveFablabsUserInfo: (username, data) => {
    return API.post(`/users/${username}/fablabs/partnerinfo`, data)
  },
  resendFablabsEmail: (username, data) => {
    return API.post(`/users/${username}/fablabs/resend`, data)
  },
  saveFablabsLinkClick: (data) => {
    return API.post('/users/partnerinfo/linkclick', data)
  },
  saveSocialHandle: (data) => {
    return API.post('/users/savesocialhandle', data)
  },
  deleteSocialHandle: (data) => {
    return API.post('/users/deletesocialhandle', data)
  },
  getSocialHandle: (userid) => {
    return API.get(`/users/${userid}/getsocialhandle`)
  },
  savePushNotificationToken: (username, data) => {
    return API.post(`/users/${username}/notifications/token`, data)
  },
  getNotifications: (username, limit, offset, count) => {
    return API.get(`/users/${username}/userNotification`, { params: { limit, offset, count } })
  },
  getUnreadNotificationsCount: (username) => {
    return API.get(`/users/${username}/userNotification/count`)
  },
  updateNotifications: (data) => {
    return API.put('/users/updateReadStatus', data)
  },
  updateAllNotifications: (data) => {
    return API.put('/users/updateReadAllStatus', data)
  },
  logHubspotID: (data) => {
    return API.post('/users/hubspot', data)
  },
  getLeaderboardUsers: () => {
    return API.get('/users/leaderboard')
  },
  getUserAwardPermissions: (username) => {
    return API.get(`/users/${username}/awards`)
  },
  saveUserResourceAnswers: (data) => {
    return API.put('/users/resource/answers', data)
  },
  saveUserResourceDownload: (resourceID, data) => {
    return API.post(`/users/resource/${resourceID}/download`, data)
  },
  saveGatedProjectUserDownload: (projectID, data) => {
    return API.post(`/users/resource/${projectID}/gateddownload`, data)
  },
  getQuestionsForUserOrResource: (userID, resourceID) => {
    return API.get('/users/resource/dynamicquestions', { params: { userID, resourceID } })
  },
  getUnansweredQuestionsForUserOrProject: (userID, projectID) => {
    return API.get('/users/resource/dynamicprojectquestions', { params: { userID, projectID } })
  },
  getInternalQuestions: (userID) => {
    return API.get(`/users/${userID}/resource/questions/internal`)
  },
  getPartnerQuestions: (userID, limit, offset) => {
    return API.get('/users/login/partnerquestions', { params: { userID, limit, offset } })
  },
  getPartnerQuestionsByGrouping: (userID, grouping, filterByType, userType, getAllQuestions) => {
    return API.get('/users/login/questionsbygrouping', { params: { userID, grouping, filterByType, userType, getAllQuestions } })
  },
  registerForWebinar: (webinarID) => {
    return API.get('/users/resource/webinar/register', { params: { webinarID } })
  },
  checkWebinarRegistration: (resourceID) => {
    return API.get('/users/resource/webinar/check', { params: { resourceID } })
  },
  isUserApprover: (userID) => {
    return API.get('/user-approver/user/check', { params: { userID } })
  },
  signupByMicrosoft: (data) => {
    return API.post('/users/signup/microsoft', data)
  },
  teacherWelcome: (username) => {
    return API.post(`/users/${username}/teacherwelcome`)
  },
  getGroupByCode: (studentCode) => {
    return API.get(`/group/getGroups?studentCode=${studentCode}`)
  },
  getClassesForStudent: (studentId) => {
    return API.get(`/group/getGroups?studentId=${studentId}`)
  },
  getClassesForTeacher: (teacherId) => {
    return API.get(`/group/getGroups?teacherId=${teacherId}`)
  },
  createGroupUser: (data) => {
    return API.post('/group/createGroupUser', data)
  },
  updateStudentStatus: (studentStatus, studentUsername) => {
    return API.post(`/group/approveOrDecline/${studentStatus}/${studentUsername}`)
  },
  createCode: () => {
    return API.post('/group/createCode')
  },
  createNewGroup: (data) => {
    return API.post('/group/createGroup', data)
  },
  updateClassName: (params) => {
    return API.post('/group/updateClass', params)
  },
  createUserName: () => {
    return API.get('/users/createUserName')
  },
  getStudentsByClass: (classId) => {
    return API.get(`/groupUsers/getStudentsByClass/${classId}`)
  },
  updateStudentData: (params) => {
    return API.post('/updateStudent', params)
  },
  deleteStudent: (studentId) => {
    return API.delete(`/users/deleteStudent/${studentId}`)
  },
  removeGroupUser: (studentId) => {
    return API.delete(`/group/removeGroupUser/${studentId}`)
  },
  addStudentByTeacher: function (params) {
    return API.post('/users/addStudentByTeacher', params)
  },
  createNewClass: function (teacherId) {
    return API.post(`/group/createNewClass/${teacherId}`)
  },
  getStudentQuestion: function () {
    return API.get('/getQuestionId')
  },
  storeStudentName: function (params) {
    return API.post('/group/storeStudentName', params)
  },
  getStudentNameAnswer: function (userId, questionId) {
    return API.get(`/getStudentAnswer/${userId}/${questionId}`)
  },
  getJacMemberDistrict: function (jacMemberId) {
    return API.get(`/user/jacDistrict/${jacMemberId}`)
  },
  checkStudentJacDistrict: function (jacStudentMemberId) {
    return API.get(`/user/studentJacDistrict/${jacStudentMemberId}`)
  },
  sendJudgeWelcomeEmail: function () {
    return API.post('/user/sendJudgeWelcomeEmail')
  },
  addResourceProjMembership: function () {
    return API.post('/user/membership/resourceProject')
  }
}
